var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9998 16.1998C12.9762 16.1998 16.1998 12.9763 16.1998 8.9998C16.1998 5.02335 12.9762 1.7998 8.9998 1.7998C5.02335 1.7998 1.7998 5.02335 1.7998 8.9998C1.7998 12.9763 5.02335 16.1998 8.9998 16.1998ZM9.8998 5.3998C9.8998 4.90275 9.49686 4.4998 8.9998 4.4998C8.50274 4.4998 8.0998 4.90275 8.0998 5.3998V8.9998C8.0998 9.2385 8.19462 9.46742 8.3634 9.6362L10.909 12.1818C11.2605 12.5333 11.8303 12.5333 12.1818 12.1818C12.5332 11.8303 12.5332 11.2605 12.1818 10.909L9.8998 8.62701V5.3998Z",
    fill: "#009B73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockFill);
export default __webpack_public_path__ + "static/media/clock-fill.dc1c413ddcd0599f95808ec19cdcd985.svg";
export { ForwardRef as ReactComponent };